import { Component } from "react";
import { Button, Card, Divider, Flex, Modal, Spin, Tabs } from "antd";
import {
  FileProtectOutlined,
  CloseOutlined,
  QrcodeOutlined,
  ExceptionOutlined,
} from "@ant-design/icons";

import { getFuncConfirmTransaction } from "../../utils/funcCallback";
import VerifySlip from "../Slipmate/verify-slip";
import VerifySlipOutQrcode from "../Slipmate/verify-slip-out-qrcode";
import { confirmSwal, openNotification } from "../../utils";
import Swal from "sweetalert2";
import { Note } from "../../screens/Verifyslip-transactions/components/note";

export class VerifySlipModel extends Component {
  instance = null;
  constructor(props) {
    super(props);
    this.state = {
      selectedForm: "Deposit (with slip)",
      loading: false,
      spinner: false,
      dataResults: null,
      showTypeVerify: "With slip",
      activeTabs: "1",
    };
    this.handleShowBtnConfirm = this.handleShowBtnConfirm.bind(this);
    this.handleChangeLoading = this.handleChangeLoading.bind(this);
    this.confirm = this.confirm.bind(this);
    this.handleConfirmTransaction = this.handleConfirmTransaction.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.show && this.props.show) {
      this.setState({ showTypeVerify: "With slip" }, () => this.confirm());
    }
  }

  handleChangeLoading = (state) => {
    this.setState({ loading: state });
  };

  onChange = (key) => {
    this.setState({ activeTabs: key });
  };

  handleShowBtnConfirm = (state, item) => {
    this.setState({ dataResults: item, spinner: state });
  };

  resetState = () => {
    this.setState({
      spinner: false,
    });
  };
  handleCloseModel = () => {
    const { handleClose } = this.props;
    if (this.instance) {
      this.instance.destroy();
      handleClose();
      this.resetState();
    }
  };

  mainContainWithQRcode() {
    const { t, isData, resAllDataMerchang } = this.props;
    const { customer_uuid } = isData;
    return (
      <VerifySlip
        t={t}
        uuid={customer_uuid}
        handleChangeLoading={this.handleChangeLoading}
        isData={isData}
        resAllDataMerchang={resAllDataMerchang}
        handleShowBtnConfirm={this.handleShowBtnConfirm}
        handleConfirmTransaction={this.handleConfirmTransaction}
      />
    );
  }

  mainContainWithoutQRcode() {
    const { t, isData, resAllDataMerchang } = this.props;
    const { customer_uuid } = isData;
    return (
      <VerifySlipOutQrcode
        t={t}
        uuid={customer_uuid}
        isData={isData}
        handleChangeLoading={this.handleChangeLoading}
        resAllDataMerchang={resAllDataMerchang}
        handleShowBtnConfirm={this.handleShowBtnConfirm}
        handleConfirmTransaction={this.handleConfirmTransaction}
      />
    );
  }

  handleConfirmTransaction = async (item) => {
    if (!item?.id) {
      Swal.fire({
        title: "เกิดข้อผิดพลาด!",
        text: "ตรวจสอบข้อมูลให้ถูกต้อง!",
        icon: "error",
      });
      this.handleCloseModel();
      return;
    }
    let onConfirm = await confirmSwal("question", "ยืนยันการทำรายการ");
    if (!onConfirm) {
      openNotification("success", "สำเร็จ", "ยกเลิกการทำรายการแล้ว");
      this.handleCloseModel();
      return;
    }
    let postData = {
      verifyId: item?.id,
    };

    try {
      const res = await getFuncConfirmTransaction(postData);
      if (res.status === "MATCHED" || res.status === "SUCCESS") {
        this.setState({
          spinner: false,
        });
        this.handleCloseModel();
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }, 500);
      } else {
        this.setState({
          spinner: false,
        });
      }
    } catch (error) {
      console.error("Failed to confirm transaction:", error);
      this.setState({ spinner: false });
    }
  };

  confirm() {
    const { spinner, activeTabs } = this.state;

    this.instance = Modal.confirm({
      title: (
        <>
          <FileProtectOutlined /> {this.props.t("Verify Slip")}
        </>
      ),
      icon: null,
      style: { top: 20 },
      width: 590,
      closable: false,
      content: (
        <>
          <div className="mb-3">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <Card
                className="pt-0 mt-0"
                style={{ border: "none", boxShadow: "none" }}
              >
                <div>
                  <Divider />
                  <Tabs
                    defaultActiveKey={activeTabs}
                    onChange={this.onChange}
                    items={[QrcodeOutlined, ExceptionOutlined].map(
                      (Icon, i) => {
                        const id = String(i + 1);
                        return {
                          key: id,
                          label: id === "1" ? "มี QRcode" : "ไม่มี QRcode",
                          children: (
                            <>
                              {/* แบบมี สลิป */}
                              <Spin spinning={spinner} tip="Loading...">
                                {id === "1" ? (
                                  <>
                                    <div
                                      className={`${id === "1" ? "show animate" : "d-none"
                                        }`}
                                      id="With slip"
                                    >
                                      {this.mainContainWithQRcode()}
                                    </div>
                                  </>
                                ) : id === "2" ? (
                                  <>
                                    {/* แบบไม่มี สลิป */}
                                    <div
                                      className={`${id === "2" ? "show animate" : ""
                                        }`}
                                      id="With out slip"
                                    >
                                      {this.mainContainWithoutQRcode()}
                                    </div>
                                  </>
                                ) : null}
                              </Spin>
                            </>
                          ),
                          icon: <Icon />,
                        };
                      }
                    )}
                  />
                </div>
              </Card>
            </div>
            
            <Note t={this.props.t}/>
          </div>
        </>
      ),

      footer: [
        <Flex gap="middle" justify="end" horizontal>
          <Button danger onClick={() => this.handleCloseModel()}>
            <CloseOutlined /> {this.props.t("Close")}
          </Button>
        </Flex>,
      ],

      maskClosable: false,
    });
  }

  render() {
    return null;
  }
}
